import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class EsipTradeUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.placeEsipTrade(req);
    }
}
export default EsipTradeUseCase;
